import React from "react";
import { Referances } from "../../assets/img/references";
import Banner from "../../assets/img/about-us.png";
import CustomBanner from "../../components/CustomBanner";
import { Helmet } from "react-helmet";
import ReferancesImage from "../../assets/img/references/referances.jpg";

const References = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="">
      <Helmet>
        <title>Referanslarımız - LENSA</title>
        <meta
          name="description"
          content="Referanslarımız sayfamızdan referanslarımızı inceleyebilirsiniz."
        />
      </Helmet>
      <CustomBanner
        title="Referanslarımız"
        breadTitle="Referanslarımız"
        image={Banner}
      />
      <div>
        <img src={ReferancesImage} alt="Referans" className="w-full h-auto" />
      </div>
    </div>
  );
};

export default References;
